var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('img',_vm._g({staticClass:"ma-2 pa-2 skill-icon",class:{
        'elevation-4': _vm.hover,
        'invert-color': _vm.darkMode,
      },attrs:{"src":_vm.src},on:{"mouseover":function($event){return _vm.$emit('mouseover')},"mouseleave":function($event){return _vm.$emit('mouseleave')}}},on))]}}])},[_c('span',[_vm._v(_vm._s(_vm.skill))])])}
var staticRenderFns = []

export { render, staticRenderFns }